import React from "react";

const AD_STYLES = `
.ad-modal-backdrop {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.45);
  z-index: var(--z-backdrop);
  opacity: 0; pointer-events: none;
  transition: opacity 0.18s ease;
  display: flex; align-items: center; justify-content: center;
}
.ad-modal-backdrop.open { opacity: 1; pointer-events: auto; }
.ad-modal {
  width: 580px; max-width: calc(100vw - 32px);
  background: #fff; border-radius: 12px; overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.06);
  transform: translateY(8px); transition: transform 0.18s ease;
  font-family: 'Montserrat';
}
.ad-modal-backdrop.open .ad-modal { transform: translateY(0); }
.ad-modal-head {
  background: #fff; padding: 18px 24px 14px;
  display: flex; align-items: flex-start; justify-content: space-between; gap: 12px;
}
.ad-modal-title { font-size: 18px; font-weight: 700; color: #1E1E1E; }
.ad-modal-close {
  background: none; border: none; cursor: pointer;
  padding: 2px; color: #757575;
  display: inline-flex; align-items: center; border-radius: 4px;
}
.ad-modal-close:hover { background: rgba(0,0,0,0.06); color: #1E1E1E; }
.ad-modal-body {
  padding: 18px 24px 24px;
  border-top: 1px solid #E6E6E6;
  display: grid; grid-template-columns: 200px 1fr;
  gap: 14px 16px;
}
.ad-modal-body label {
  font-size: 14px; font-weight: 600; color: #1E1E1E;
}
.ad-modal-body .ad-val {
  font-size: 14px; font-weight: 400; color: #1E1E1E;
}
`;

function AuditDetailsModalV2({ onClose, audit, auditType }: any) {
  return (
    <>
      <style>{AD_STYLES}</style>
      <div className="ad-modal-backdrop open">
        <div className="ad-modal" role="dialog" aria-modal="true">
          <div className="ad-modal-head">
            <div className="ad-modal-title">Audit Details</div>
            <button className="ad-modal-close" onClick={onClose} aria-label="Close">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div className="ad-modal-body">
            <label>Company:</label>
            <div className="ad-val">{(audit.company || {}).name || '—'}</div>

            <label>Associate Company:</label>
            <div className="ad-val">{(audit.associate_company || {}).name || '—'}</div>

            <label>Location:</label>
            <div className="ad-val">{(audit.location || {}).name || '—'}</div>

            {auditType === "vendor_location" && <>
              <label>Vendor Category:</label>
              <div className="ad-val">{(audit.vendor_category || {}).name || '—'}</div>
              <label>Vendor:</label>
              <div className="ad-val">{(audit.vendor_registration || {}).vendor_name || '—'}</div>
            </>}

            <label>Month &amp; Year:</label>
            <div className="ad-val">{audit.month} ({audit.year})</div>

            {audit.status === 'dropped_audit' && ((audit.metadata || {}).drop_reason) && <>
              <label>Drop Reason:</label>
              <div className="ad-val">{(audit.metadata || {}).drop_reason}</div>
            </>}
          </div>
        </div>
      </div>
    </>
  );
}

export default AuditDetailsModalV2;
